import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";
import { Globe } from "lucide-react";

interface LanguageSelectorProps {
  variant?: "default" | "light";
}

export const LanguageSelector = ({ variant = "default" }: LanguageSelectorProps) => {
  const { language, setLanguage } = useLanguage();

  const toggle = () => setLanguage(language === "en" ? "fr" : "en");

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={toggle}
      className={`text-xs font-bold gap-1.5 transition-all ${
        variant === "light"
          ? "border-white/40 bg-white/15 text-white hover:bg-white/25 hover:text-white"
          : "border-[#1D314D]/30 bg-[#1D314D] text-white hover:bg-[#2E4663] hover:text-white"
      }`}
    >
      <Globe className="h-3.5 w-3.5" />
      {language === "en" ? "FR" : "EN"}
    </Button>
  );
};
